module.exports = __webpack_public_path__ + "static/media/S1-4-Dogorb-cod4.f0cf2a28.png";